export const MAX_RELATED_ACCOUNTS_IS_KID = 12;
